module.exports = __webpack_public_path__ + "static/young-leader-photo-marie_michele_larivee-21bc5844c828399c35b5ba2ce14a90eb.jpg";